/**
 * 集成凭据管理路由。
 */
import type { RouteRecordRaw } from "vue-router";

export const integrationRoutes: RouteRecordRaw[] = [
  {
    path: "/integration-credentials",
    name: "IntegrationCredentials",
    component: () => import("./interfaces/CredentialAdminView.vue"),
    meta: {
      title: "集成凭据",
      requiresAuth: true,
      keepAlive: false,
      breadcrumb: ["集成凭据"],
    },
  },
];

export default integrationRoutes;
